import { trpcSwr } from '../../../api/trpc';

export const useUtmList = () => {
  const { data, isLoading, error, mutate } = trpcSwr.utmAdmin.list.useSWR();

  return { data, isLoading, error, mutate };
};
